import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import Button from '@mui/material/Button';
import 'ag-grid-enterprise';
import * as Flags from 'country-flag-icons/react/3x2'
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import { countryToAlpha2 } from 'country-to-iso';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { useMediaQuery, useTheme } from '@mui/material';

const ContainerTypeList = () => {
      const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.container}`;
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const [gridApi, setGridApi] = useState(null);
    const perPage = 10;
    const [error, setError] = useState("")
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const gridRef = useRef();
    const navigate = useNavigate();
    const [columnDefs, setColumnDefs] = useState([
        { field: 'name', enableRowGroup: true,headerName: 'Container Name',minWidth:50 },
        { field: 'uniqueCode', enableRowGroup: true ,headerName: 'Container Unique Code',minWidth:50 },
        { field: 'minVolume', enableRowGroup: true,headerName: 'Minimum Volume (CBM)' ,minWidth:50 },
        { field: 'maxVolume', enableRowGroup: true,headerName: 'Maximum Volume (CBM)' ,minWidth:50 },
        { field: 'mixedMaxVolume', enableRowGroup: true,headerName: 'Maximum Volume for Mix Products (CBM)' ,minWidth:50 },
        { field: 'weight', enableRowGroup: true,headerName: 'Container Weight (KG)',minWidth:50},
        { field: 'modeOfShipment', enableRowGroup: true, headerName: 'Mode of Shipment',minWidth:50},
    ]);

    const findContainerTypes = async () => {
        try {
            const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
            let containerTypes = list.data?._embedded?.containers
            containerTypes = containerTypes.map((curEl) => {
                let str = curEl._links.self.href
                str = str.split("/")
                let id = str[str.length - 1]

                return {
                    id: id,
                    name: curEl.name,
                    uniqueCode: curEl.uniqueCode,
                    minVolume: curEl.minVolume,
                    maxVolume: curEl.maxVolume,
                    mixedMaxVolume: curEl.mixedMaxVolume,
                    weight: curEl.weight,
                    modeOfShipment: curEl.modeOfShipment
                }
            });
            setRowData(containerTypes);
        } catch (error) {
            console.log('error', error)
            setError(error.message);
        }
    }

    const onGridReady = useCallback((params) => {
        findContainerTypes();
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, []);

    const onBtExport = useCallback(() => {
        const params = {
            fileName: 'ContainerTypes.xlsx',
            sheetName: 'Container Types'
        }
        gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            // var filename = row?._links?.user?.href.split('/').pop()
            try {
                await OAuthService.deleteData(url, row.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
                findContainerTypes();
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const onSelectionChanged = (params) => {
        // console.log("idd", params.api.getSelectedRows()[0], params);
        setSelectedRows(params.api.getSelectedRows());
    }

   
const goToRoleEdit = useCallback(
  (data) => {
    if (data?.id !== undefined) {
      navigate("/editContainerType/" + data.id);
    }
  },
  [navigate],
);
  const onRowDoubleClicked = (params) => {
    if (isMobile) return; 
    goToRoleEdit(params?.data);
  };

  const onRowClicked = (params) => {
    if (!isMobile) return; 
    goToRoleEdit(params?.data);
  };
   
    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows])

    return (
        <>
            <ListPageHeader
                componentName="Container Type"
                onBtExport={onBtExport}
                handlePurge={handlePurge}
                deleteDisable={deleteDisable}
                addPageLink="/addContainerType"
                pageName="Container Type List"
                error={error}
                successMsg={successMsg}
                gridRef={gridRef}
                snackState={snackState}
            />
            <div className="h-full">
                <AgGridTable
                    rowData={rowData}
                    columnDefs={columnDefs}
                    onGridReady={onGridReady}
                    onSelectionChanged={onSelectionChanged}
                    onRowDoubleClicked={onRowDoubleClicked}
                    onRowClicked={onRowClicked}
                    gridRef={gridRef}
                    paginationPageSize={perPage}
                    cacheBlockSize={perPage}
                    saveGridStateName={'containerTypeList'}
                />
            </div>
        </>
    )
}

export default ContainerTypeList